import React, {PureComponent} from "react";
import {Table} from "reactstrap";
import {i18nizeDate} from "../helpers/Utils";
import {withTranslation} from "react-i18next";
import UserInfo from "../components/UserInfo";
import Rbac from "../components/Rbac";

class BankPaymentDetails extends PureComponent {
  render() {
    const {t, transaction, showBankDepositFeedbackForm} = this.props;
    const {rejectReason, verifiedAt, verifiedBy, status} = transaction;
    return (
      <div className="table-row-sub py-2">
        <Table bordered responsive>
          <tbody>
            {status === "REJECTED" &&
              <tr>
                <td style={{width: 150}} className="text-info">{t('Rejection Reason')}</td>
                <td className='d-flex flex-row align-items-center'>
                  <span>{rejectReason}</span>
                  <Rbac permission='update_bank-deposit'>
                    <i className='icon-Pencil cursor-pointer text-large text-primary mx-1'
                       onClick={() => {showBankDepositFeedbackForm('UPDATE', transaction);}}/>
                  </Rbac>
                </td>
              </tr>
            }
            {!!verifiedAt &&
              <tr>
                <td style={{width: 150}} className="text-info">{t('Validation Date')}</td>
                <td className='d-flex flex-row align-items-center'>
                  <span>{i18nizeDate(verifiedAt)}</span>
                </td>
              </tr>
            }
            {!!verifiedBy &&
              <tr>
                <td style={{width: 150}} className="text-info">{t('Evaluated By')}</td>
                <td className='d-flex flex-row align-items-center'>
                  <span>
                    <UserInfo
                      textColor="text-dark"
                      label={t('Admin')}
                      id={verifiedBy}
                      type="ADMIN"
                    />
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withTranslation()(BankPaymentDetails);